export const { DEV, PROD, MODE, SSR } = import.meta.env

const BACKEND_DEV_HTTP = window.location.hostname + ':3011';
const PUBLIC_HTTP = 'belotmasters.com';

export const BACKEND_URI = DEV ? BACKEND_DEV_HTTP : PUBLIC_HTTP;
export const BACKEND_HTTP = (DEV ? 'http://' : "https://") + BACKEND_URI;
export const BACKEND_WS = (DEV ? 'ws://' : "wss://") + BACKEND_URI + (PROD ?  "/api" : "");
export const PUBLIC_FILES_BASE = (DEV ? BACKEND_HTTP : window.location.origin) + '/public'